import { useState } from "react";
import { AiFillFileAdd } from "react-icons/ai";
import { AiFillCloseCircle } from "react-icons/ai";
import axios from "axios";
import { Alert, Snackbar } from "@mui/material";
const Addtestimonials = () => {
  const [name, setName] = useState("");
  const [message, setMessage] = useState("");
  const [file, setFile] = useState(null);
  const [img, setImg] = useState();
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [serverMessage, setServerMessage] = useState("");
  const convertbase64 = async (file) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = () => {
      setImg(fileReader.result);
    };
    fileReader.onerror = (error) => {
      console.log(error);
    };
  };
  const handleUpload = async (e) => {
    setFile(e.target.files[0]);
    const file = e.target.files[0];
    await convertbase64(file);
  };
  const handleClient = async () => {
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/client`,
        {
          name,
          message,
          image: img,
        }
      );
      console.log(data);
      setServerMessage(data);
      setSuccess(true);
      setOpen(true);
      setName("");
      setMessage("");
      setImg('')
      setFile(null);
    } catch (error) {
      console.log(error.response.data.error);
      serverMessage(error.response.data.error);
      setOpen(true);
    }
  };

  const [open, setOpen] = useState(false);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  return (
    <div className="mt-20 sm:ml-5  relative w-full">
      <div className="flex lg:flex-row flex-col lg:justify-around justify-center items-center">
        <div className="flex flex-col">
          <input
            className="border focus:border-[#FE4904] border-black-500 outline-none h-[50px] px-4 py-6 text-lg rounded-lg sm:w-[400px] w-[300px] my-3"
            type="text"
            placeholder="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <textarea
            name="message"
            id=""
            onChange={(e) => setMessage(e.target.value)}
            rows="5"
            placeholder="Message"
            value={message}
            className="border  focus:border-[#FE4904] sm:w-[400px] w-[300px] outline-none rounded-lg px-4 py-6 resize-none text-lg border-black-500"
          ></textarea>
        </div>
        <div className="flex flex-col items-center">
          <div
            id="dropzone"
            className="border border-dashed lg:mt-0 mt-3 sm:w-[400px] w-[300px] h-[200px] relative flex justify-center items-center"
          >
            {file ? (
              <div className="relative w-full">
                <img
                  className="sm:w-[400px] w-[300px] h-[200px] object-contain"
                  src={URL.createObjectURL(file)}
                  alt=""
                />
                <AiFillCloseCircle
                  onClick={() => setFile(null)}
                  className="absolute top-2 right-2 text-2xl text-gray-700"
                />
              </div>
            ) : (
              <span className="">Select picture to see the preview</span>
            )}
          </div>
          <input type="file" id="fileInput" onChange={handleUpload} hidden />
          <button className="bg-gradient-to-r mt-3 w-[150px] from-[#FE4904] to-[#F7164C] flex items-center text-white rounded-lg py-2 px-4 ">
            <label htmlFor="fileInput" className="w-[150px] cursor-pointer">
              <AiFillFileAdd className="w-[25px] mr-2 inline-flex h-[25px] text-center object-cover ml-2 cursor-pointer" />
              <span>Add Pic</span>
            </label>
          </button>
        </div>
      </div>
      <div className="w-full flex items-center justify-center">
        <button
          onClick={handleClient}
          className="border border-[#FE4904] px-2 py-2 rounded-lg mt-4"
        >
          Add Client
        </button>
      </div>
      {open && (
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert
            onClose={handleClose}
            severity={`${success}` ? "success" : "error"}
            sx={{ width: "100%" }}
          >
            {serverMessage}
          </Alert>
        </Snackbar>
      )}
    </div>
  );
};
export default Addtestimonials;
